import { useContext, useState, useEffect } from 'react';
import './Results.css';
import { FormattedMessage } from 'react-intl';
import { useHistory } from "react-router-dom";
import messages from '../../lang/preferences';
import Axios from 'axios';
import { StepContext } from '../../contexts/StepContext';
import { SlidesContext } from '../../contexts/SlidesContext';
//import { ChronoContext } from '../../contexts/ChronoContext';
import url from '../../constants/urlsPaths';
import logger from '../../utils/frontendLogger';

export default function Results({ slide }) {
    const { step } = useContext(StepContext);
    const { slidesAnswers } = useContext(SlidesContext);
    const [loading, setLoading] = useState(true);
    //const { chrono } = useContext(ChronoContext);
    let history = useHistory();

    useEffect(() => {
        getResults(slidesAnswers);
    }, [slidesAnswers])

    /*const addZero = (time) => {
        if (time < 10) {
            return "0" + time
        }
        else
            return time
    }
     */       
    const getResults = (answers) => {
        logger.info('Test submission initiated', 'test_submit', {
            answersCount: answers.length,
            userCode: sessionStorage.getItem("code")
        });

        Axios.post(url.saveResults, { answers: answers, code: sessionStorage.getItem("code") }, {
            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
        })
            .then(res => {
                if (res.data.auth === false) {
                    logger.error('Test submission failed: user not found', 'test_submit_error', {
                        userCode: sessionStorage.getItem("code")
                    });
                    alert("Error: cannot find user, you'll be disconnected")
                    sessionStorage.clear(); window.location.reload();
                }
                else {
                    logger.info('Test submission successful', 'test_submit_success', {
                        userCode: sessionStorage.getItem("code")
                    });
                    sessionStorage.setItem('graphs', res.data)
                    setTimeout(function () {
                        setLoading(false)
                    }, 2000);
                }
            })
            .catch(err => { 
                logger.error('Test submission error', 'test_submit_error', {
                    error: err.message,
                    userCode: sessionStorage.getItem("code")
                });
                console.log(err) 
            })
    }
    const seeResults = () => {
        history.push('/results')
    }
    return (
        loading ?
            <div style={{ width: "100vw", height: "100vh", zIndex: '99999', color: "black", position: 'fixed', top: "0", left: "0", fontSize: "20px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                <FormattedMessage {...messages.LOADING_PAGE}>
                    {(msg) => (<h3>{msg}</h3>)}
                </FormattedMessage>
            </div>
            :
            <div className="Results">
                <div className="Results-header">
                    <h1 className="Results-title">
                        <FormattedMessage {...slide[step].title} />
                    </h1>
                    <p className="Results-informations">
                        <FormattedMessage {...slide[step].accueils.accueil1} />
                    </p>
                    {/* <p className="Results-informations">
                        <FormattedMessage {...slide[step].accueils.accueil2} />
                        </p>
                        <div className="Results-chrono">
                        <span>{addZero(chrono.hours)}:</span> 
                        <span>{addZero(chrono.minutes)}:</span>
                        <span>{addZero(chrono.seconds)}</span>
                        </div> */
                    }
                    <button className="Results-see-results" onClick={seeResults}><FormattedMessage {...messages.BTNVOIRRESULTATS} /></button>
                </div>
            </div>
    );
}
